import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Notify that a flash has been inserted and is visible
    try {
      window.dispatchEvent(new Event('flash:shown'))
    } catch (e) {}

    // Auto-dismiss after a short duration to avoid lingering
    setTimeout(() => {
      this.dismiss()
    }, 1500)
  }

  dismiss() {
    this.element.classList.add("opacity-0", "transition-opacity", "duration-500")
    setTimeout(() => {
      this.element.remove()
    }, 500)
  }
}
